import { BetType } from 'betweb-openapi-axios'

export const BET_TYPES_OPTIONS = (t) => [
  { value: BetType.Ordinar, label: t('ordinar') },
  { value: BetType.Express, label: t('express') },
  { value: BetType.System, label: t('system') }
]
